module.exports = __webpack_public_path__ + "static/media/ca.7cda37ce.svg";